import React from 'react';
import ActionButtons from './Buttons/ActionButtons';

function ConfirmationModal({ type, setModal, resetList, resetProducts, emptyProducts }) {
	const handleConfirmBtnClick = () => {
		if (type === 'reset-list') {
			setModal(false);
			resetList();
		} else if (type === 'reset-products') {
			setModal(false);
			resetProducts();
		} else if (type === 'empty-products') {
			setModal(false);
			emptyProducts();
		}
	};

	return (
		<div className="modalBackground" onClick={() => setModal(false)}>
			<div className="modal__message">
				{type === 'reset-list' ? <p className="modal__p">Voulez-vous réinitialisez votre liste ?</p> : ''}
				{type === 'reset-products' ? (
					<p className="modal__p">Voulez-vous réinitialisez votre liste de produits ?</p>
				) : (
					''
				)}
				{type === 'empty-products' ? (
					<p className="modal__p">Voulez-vous vider votre liste de produits ?</p>
				) : (
					''
				)}

				<ActionButtons cancel={{ method: () => setModal(false) }} confirm={{ method: handleConfirmBtnClick }} />
			</div>
		</div>
	);
}

export default ConfirmationModal;
